import type { FC, ReactNode } from 'react';

import useBreakpoint from '@/hooks/use-break-point';
import { cn } from '@/lib/utils';

interface DrawerContainerProps {
  isToastVisible?: boolean;
  children: ReactNode;
}

const DrawerContainer: FC<DrawerContainerProps> = ({ isToastVisible, children }) => {
  const isMobile = useBreakpoint('mobile');

  return (
    <div
      className={cn('fixed left-0 bottom-13 bg-white w-dvw h-fit transition-all duration-300', {
        'max-w-[365px] left-3 bottom-16 rounded-sm': !isMobile,
        'bottom-25!': isToastVisible,
        'bottom-23!': isMobile && isToastVisible,
      })}
    >
      {children}
    </div>
  );
};

export default DrawerContainer;
